var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBellNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "222 14 20 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M231.13,16.02c-.29-.29-.7-.48-1.12-.48-.45,0-.86.19-1.15.48-.29.29-.45.7-.45,1.12v.21c-1.34.35-2.51,1.12-3.45,2.19-1.28,1.44-2.06,3.45-2.09,5.67-.03,5.05-.72,5.91-1.42,6.74-.43.48-.86.99-1.18,2.06-.03.08-.03.13-.03.21,0,.29.24.56.56.56h6.44c0,.75.29,1.44.8,1.92.51.51,1.18.83,1.95.83s1.44-.32,1.95-.83c.48-.48.8-1.18.8-1.92h6.44v-.03h.16c.27-.11.45-.4.37-.7-.35-1.12-.75-1.6-1.18-2.11-.72-.83-1.42-1.68-1.44-6.74,0-2.22-.8-4.22-2.08-5.67-.94-1.07-2.11-1.84-3.45-2.19.03-.08.03-.13.03-.21,0-.43-.19-.83-.48-1.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBellNav);
export default __webpack_public_path__ + "static/media/header-bell-nav.3317e83eb28545366cf80d7f1410204c.svg";
export { ForwardRef as ReactComponent };